<app-header [background]="true"></app-header>
<app-breadcrumb [breadcrumb]="breadcrumb"></app-breadcrumb>
<section class="mainSection" *ngIf="areaData && challengeData && indicatorData">
  <div class="container">
    <div class="row">
      <div class="col-md-12 col-xxl-10 mb-5">
        <h3 class="titleArea mb-3">{{ challengeData.name }}</h3>
        <h3 class="titleAnalysis">
          ANÁLISE DE DESEMPENHO -
          <div class="btn-group dropdown">
            <button
              id="single-button"
              type="button"
              class="dropdown-year-of-title-btn"
              (click)="toggleDropdownYearOfTitle()"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {{ selectedYear }}
              <span class="caret"></span>
            </button>
            <ul
              class="dropdown-menu"
              *ngIf="dropdownOpenYearOfTitle"
              role="menu"
              style="left: auto"
              aria-labelledby="single-button"
            >
              <li role="menuitem" *ngFor="let year of allYears">
                <a (click)="selectYearOfTitle(year)">{{ year }}</a>
              </li>
            </ul>
          </div>
        </h3>
        <div class="row indicators" [hidden]="false">
          <div>
            <div class="row card-container card-container-metricas">
              <div class="col-lg-3 item-card-metricas cards-indicadores">
                <div class="overview mb-1 mt-2">
                  <span class="ball-item green-ball-img">{{
                    countScoreYear?.green || 0
                  }}</span>
                </div>
                <span class="info-text">Meta <br />atingida</span>
                <div class="card-cor-verde mini-legenda">≥ 100%</div>
              </div>
              <div class="col-lg-3 item-card-metricas cards-indicadores">
                <div class="overview mb-1 mt-2">
                  <span class="ball-item yellow-ball-img">{{
                    countScoreYear?.yellow || 0
                  }}</span>
                </div>
                <span class="info-text"
                  >Meta parcialmente<br />
                  atingida</span
                >
                <div class="card-cor-amarela mini-legenda">
                  ≥ 75% e &lt; 100%
                </div>
              </div>
              <div class="col-lg-3 item-card-metricas cards-indicadores">
                <div class="overview mb-1 mt-2">
                  <span class="ball-item red-ball-img">{{
                    countScoreYear?.red || 0
                  }}</span>
                </div>
                <span class="info-text cards-indicadores"
                  >Meta não <br />atingida</span
                >
                <div class="card-cor-verm mini-legenda">&lt; 75%</div>
              </div>
              <div class="col-lg-3 item-card-metricas cards-indicadores">
                <div class="overview mb-1 mt-2">
                  <span class="ball-item gray-ball-img">{{
                    countScoreYear?.gray || 0
                  }}</span>
                </div>
                <span class="info-text">Não é possível <br />mensurar</span>
                <div class="card-cor-preta mini-legenda"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-select">Selecione um indicador:</div>
        <div class="btn-group dropdown" style="width: 100%">
          <button
            id="single-button"
            type="button"
            class="dropdown-btn"
            (click)="toggleDropdown()"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {{ selectedIndicator?.name ?? "-- Selecione um indicador --" }}
            <span class="caret"></span>
          </button>
          <ul
            class="dropdown-menu"
            *ngIf="dropdownOpen"
            role="menu"
            aria-labelledby="single-button"
          >
            <li role="menuitem" *ngFor="let indicator of indicatorData">
              <a (click)="selectIndicator(indicator)">{{ indicator.name }}</a>
            </li>
          </ul>
        </div>
        <div class="row indicators" *ngIf="selectedIndicator">
          <ul class="d-flex indicador-header-container">
            <li class="d-flex-colum indicador-header-item">
              <span class="info-text">ORGÃO:</span>
              <span class="bck-blue medidas-text">{{
                selectedIndicator.organizationAcronym
              }}</span>
            </li>
            <li class="d-flex-colum indicador-header-item">
              <span class="info-text">UND. MEDIDA :</span>
              <span class="bck-blue medidas-text">{{
                selectedIndicator.measureUnit
              }}</span>
            </li>
            <li
              class="d-flex-colum indicador-header-item indicador-header-polaridade"
            >
              <span class="info-text">POLARIDADE:</span>
              <span
                *ngIf="
                  selectedIndicator.polarity == 'Positiva' ||
                  selectedIndicator.polarity == 'Positivo'
                "
                class="bck-blue medidas-text d-flex"
              >
                <div class="icone-polaridade"></div>
                <div>QUANTO MAIOR MELHOR</div>
              </span>
              <span
                *ngIf="
                  selectedIndicator.polarity == 'Negativa' ||
                  selectedIndicator.polarity == 'Negativo'
                "
                class="bck-blue medidas-text d-flex"
              >
                <div
                  class="icone-polaridade"
                  style="transform: rotate(180deg)"
                ></div>
                <div>QUANTO MENOR MELHOR</div>
              </span>
            </li>
            <li
              class="indicador-header-item indicador-header-ods"
              style="margin-right: 0%; width: 20%"
            >
              <div class="item-ods">
                <img
                  *ngFor="let ods of selectedIndicator.ods"
                  [src]="'/assets/images/ODS/ODS-' + ods + '.png'"
                  [alt]="'ODS ' + ods"
                  class="ods-image"
                />
              </div>
            </li>
          </ul>
        </div>
        <div class="row" *ngIf="selectedIndicator">
          <div class="table-resultados-container">
            <table class="performance-table mobile-table">
              <thead>
                <tr>
                  <th class="header-cell">
                    BASE DE REFERÊNCIA
                    <div
                      *ngIf="selectedIndicator.justificationBase"
                      class="info-justification"
                      [title]="selectedIndicator.justificationBase"
                    >
                      <i
                        class="fas fa-info-circle"
                        style="margin-left: 3px"
                      ></i>
                    </div>
                  </th>
                  <th class="header-cell">ANO</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="body-cell">
                    {{
                      indicatorBaseYearTargetResult?.times?.[0]?.showValueGoal?.slice(
                        0,
                        1000
                      ) || "-"
                    }}
                  </td>
                  <td class="body-cell">
                    {{ indicatorBaseYearTargetResult?.year || "-" }}
                  </td>
                </tr>
              </tbody>
            </table>
            <table class="performance-table">
              <tr>
                <th rowspan="2" class="header-cell hide-on-desktop">
                  BASE DE REFERÊNCIA
                  <div
                    *ngIf="selectedIndicator.justificationBase"
                    class="info-justification"
                    [title]="selectedIndicator.justificationBase"
                  >
                    <i class="fas fa-info-circle" style="margin-left: 3px"></i>
                  </div>
                </th>
                <th rowspan="2" class="header-cell hide-on-desktop">ANO</th>

                <ng-container *ngIf="showCurrentYear">
                  <th
                    colspan="3"
                    class="header-cell year"
                    [ngClass]="{ invisible: !indicatorFirstYearTargetResult }"
                  >
                    {{ indicatorFirstYearTargetResult?.year }}
                  </th>
                </ng-container>
                <th
                  colspan="3"
                  class="header-cell year hide-on-desktop"
                  *ngIf="selectedYearTargetResult"
                  [ngClass]="{
                    invisible:
                      selectedYear === areaData.startOfAdministrationYear,
                  }"
                >
                  <div class="btn-group dropdown">
                    <button
                      id="single-button"
                      type="button"
                      class="dropdown-year-btn"
                      (click)="toggleDropdownYear()"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      {{
                        selectedYearTargetResult
                          ? selectedYearTargetResult.year
                          : "Selecionar ano"
                      }}
                      <span class="caret"></span>
                    </button>
                    <ul
                      class="dropdown-menu"
                      *ngIf="dropdownOpenYear"
                      role="menu"
                      style="left: auto"
                      aria-labelledby="single-button"
                    >
                      <ng-container
                        *ngFor="let indicator of indicatorYearTargetResult"
                      >
                        <li
                          *ngIf="
                            indicator.year !==
                            areaData.startOfAdministrationYear
                          "
                          role="menuitem"
                        >
                          <a
                            style="padding: 0px 15px"
                            (click)="selectYear(indicator)"
                            >{{ indicator.year }}</a
                          >
                        </li>
                      </ng-container>
                    </ul>

                    <div class="type-year-dropwdown">
                      <ng-container
                        *ngFor="let item of selectedIndicator.times"
                      >
                        <div
                          *ngIf="
                            verifyTypeYear(
                              item.year,
                              selectedYear,
                              item.type
                            ) && verifyYearIndicator(item.year, selectedYear)
                          "
                          class="info-justification"
                          [title]="item.justificationResult"
                        >
                          Bianual
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </th>
              </tr>
              <tr>
                <ng-container *ngIf="showCurrentYear">
                  <th class="subheader-cell">
                    META
                    <ng-container *ngFor="let item of selectedIndicator.times">
                      <div
                        *ngIf="
                          item.justificationGoal &&
                          verifyYearIndicator(
                            item.year,
                            indicatorFirstYearTargetResult?.year
                          )
                        "
                        class="info-justification"
                        [title]="item.justificationGoal"
                      >
                        <i class="fas fa-info-circle"></i>
                      </div>
                    </ng-container>
                  </th>
                  <th class="subheader-cell">
                    REALIZADO
                    <ng-container *ngFor="let item of selectedIndicator.times">
                      <div
                        *ngIf="
                          item.justificationResult &&
                          verifyYearIndicator(
                            item.year,
                            indicatorFirstYearTargetResult?.year
                          )
                        "
                        class="info-justification"
                        [title]="item.justificationResult"
                      >
                        <i class="fas fa-info-circle"></i>
                      </div>
                    </ng-container>
                  </th>
                  <th class="subheader-cell">DESEMPENHO</th>
                </ng-container>
                <ng-container
                  *ngIf="
                    selectedYearTargetResult &&
                    selectedYear !== areaData.startOfAdministrationYear
                  "
                >
                  <th
                    class="subheader-cell hide-on-desktop"
                    [ngClass]="{ invisible: !indicatorFirstYearTargetResult }"
                  >
                    META
                    <ng-container *ngFor="let item of selectedIndicator.times">
                      <div
                        *ngIf="
                          item.justificationGoal &&
                          verifyYearIndicator(item.year, selectedYear)
                        "
                        class="info-justification"
                        [title]="item.justificationGoal"
                      >
                        <i class="fas fa-info-circle"></i>
                      </div>
                    </ng-container>
                  </th>
                  <th
                    class="subheader-cell hide-on-desktop"
                    [ngClass]="{ invisible: !indicatorFirstYearTargetResult }"
                  >
                    REALIZADO
                    <ng-container *ngFor="let item of selectedIndicator.times">
                      <div
                        *ngIf="
                          item.justificationResult &&
                          verifyYearIndicator(item.year, selectedYear)
                        "
                        class="info-justification"
                        [title]="item.justificationResult"
                      >
                        <i class="fas fa-info-circle"></i>
                      </div>
                    </ng-container>
                  </th>
                  <th
                    class="subheader-cell hide-on-desktop"
                    [ngClass]="{ invisible: !indicatorFirstYearTargetResult }"
                  >
                    DESEMPENHO
                  </th>
                </ng-container>
              </tr>
              <tr>
                <td class="body-cell hide-on-desktop" rowspan="2">
                  {{
                    indicatorBaseYearTargetResult?.times?.[0]?.showValueResult?.slice(
                      0,
                      1000
                    ) || "-"
                  }}
                </td>
                <td class="body-cell hide-on-desktop" rowspan="2">
                  {{ indicatorBaseYearTargetResult?.year || "-" }}
                </td>
                <ng-container *ngIf="showCurrentYear">
                  <td
                    class="body-cell"
                    [ngClass]="{ invisible: !indicatorFirstYearTargetResult }"
                  >
                    {{
                      indicatorFirstYearTargetResult?.times?.[0]?.showValueGoal ||
                        "Sem dados"
                    }}
                  </td>
                  <td
                    class="body-cell"
                    [ngClass]="{ invisible: !indicatorFirstYearTargetResult }"
                  >
                    {{
                      indicatorFirstYearTargetResult?.times?.[0]?.showValueResult ||
                        "Sem dados"
                    }}
                  </td>
                  <td
                    class="body-cell"
                    [ngClass]="{ invisible: !indicatorFirstYearTargetResult }"
                  >
                    <span
                      *ngIf="indicatorYearTargetResult"
                      class="ball-item {{ ballClassCurrentYear }}"
                    >
                    </span>
                    <span
                      *ngIf="!indicatorYearTargetResult"
                      class="ball-item mirrored-grey-ball-img"
                    ></span>
                  </td>
                </ng-container>
                <ng-container
                  *ngIf="
                    selectedYearTargetResult &&
                    selectedYear !== areaData.startOfAdministrationYear
                  "
                >
                  <td class="body-cell hide-on-desktop">
                    {{
                      selectedYearTargetResult?.times?.[0]?.showValueGoal ||
                        "Sem dados"
                    }}
                  </td>
                  <td class="body-cell hide-on-desktop">
                    {{
                      selectedYearTargetResult?.times?.[0]?.showValueResult ||
                        "Sem dados"
                    }}
                  </td>
                  <td class="body-cell hide-on-desktop">
                    <span
                      *ngIf="selectedYearTargetResult"
                      class="ball-item {{ ballClassYearTargetResult }}"
                    >
                    </span>
                  </td>
                </ng-container>
              </tr>
            </table>
            <table
              class="performance-table mobile-table"
              *ngIf="
                selectedYearTargetResult &&
                selectedYear !== areaData.startOfAdministrationYear
              "
            >
              <tr>
                <th colspan="3" class="header-cell year">
                  <div class="btn-group dropdown">
                    <button
                      id="single-button"
                      type="button"
                      class="dropdown-year-btn"
                      (click)="toggleDropdownYear()"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      {{
                        selectedYearTargetResult
                          ? selectedYearTargetResult.year
                          : "Selecionar ano"
                      }}
                      <span class="caret"></span>
                    </button>
                    <ul
                      class="dropdown-menu"
                      *ngIf="dropdownOpenYear"
                      role="menu"
                      style="left: auto"
                      aria-labelledby="single-button"
                    >
                      <ng-container
                        *ngFor="let indicator of indicatorYearTargetResult"
                      >
                        <li
                          *ngIf="
                            indicator.year !==
                            areaData.startOfAdministrationYear
                          "
                          role="menuitem"
                        >
                          <a
                            style="padding: 0px 15px"
                            (click)="selectYear(indicator)"
                            >{{ indicator.year }}</a
                          >
                        </li>
                      </ng-container>
                    </ul>
                  </div>
                </th>
              </tr>
              <tr>
                <th class="subheader-cell">
                  META
                  <div
                    *ngIf="
                      selectedYearTargetResult?.times?.[0]?.justificationGoal
                    "
                    class="info-justification"
                    [title]="
                      selectedYearTargetResult?.times?.[0]?.justificationGoal
                    "
                  >
                    <i class="fas fa-info-circle"></i>
                  </div>
                </th>
                <th class="subheader-cell">REALIZADO</th>
                <th class="subheader-cell">DESEMPENHO</th>
              </tr>
              <tr>
                <td class="body-cell">
                  {{
                    selectedYearTargetResult?.times?.[0]?.showValueGoal ||
                      "Sem dados"
                  }}
                </td>
                <td class="body-cell">
                  {{
                    selectedYearTargetResult?.times?.[0]?.showValueResult ||
                      "Sem dados"
                  }}
                </td>
                <td class="body-cell">
                  <span
                    *ngIf="selectedYearTargetResult"
                    class="ball-item {{ ballClassYearTargetResult }}"
                  ></span>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div
          *ngIf="selectedIndicator?.originalFileName"
          class="download-pdf"
          (click)="downloadPdf()"
        >
          <i class="fas fa-download me-2"></i>
          <span>Ficha do indicador</span>
        </div>
      </div>
      <div class="col-md-12 col-xxl-2 text-center">
        <div class="card CardAreas custom-shadow">
          <div class="card-body">
            <h5 class="card-title">Desafios</h5>
            <ul class="menuLateral mb-0">
              <ng-container *ngFor="let challenge of areaData.challenge">
                <li
                  class="nav-item"
                  [ngClass]="{ active: challengeId == challenge.uuId }"
                >
                  <a
                    class="nav-link d-flex"
                    [routerLink]="['/challenge']"
                    [queryParams]="{ id: challenge.uuId }"
                  >
                    <div class="textAreaMenu">
                      {{ challenge.name }}
                    </div>
                  </a>
                </li>
              </ng-container>
            </ul>
          </div>
        </div>
      </div>
    </div>
    &nbsp;
  </div>
</section>
<app-footer></app-footer>
